import { render, staticRenderFns } from "./RoleListView.vue?vue&type=template&id=5f3ad9ed"
import script from "./RoleListView.vue?vue&type=script&lang=js"
export * from "./RoleListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports